import { theme } from '../styles/theme/phc';
import { useMediaQuery } from '@mui/material';

function useIsMobile() {
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  return matches;
}

export default useIsMobile;
